const ACTION = {
    UPDATE_BANK_PHONE_NUMBER: 'UPDATE_BANK_PHONE_NUMBER',
    UPDATE_BANK_PHONE_NUMBER_ERROR_TEXT: ' UPDATE_BANK_PHONE_NUMBER_ERROR_TEXT',
}

export default ACTION;